
import * as actions from 'actions';
import byPageMaker from 'reducersMakers/byPageMaker';

export default byPageMaker([actions.MAIL_THREAD_MESSAGES_FETCH_SUCCESS], 'threadMessagesIds');



/** WEBPACK FOOTER **
 ** ./src/members/state/mail/mailThreadMessages/byThreadId/byPage/reducer.js
 **/